import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

/**
 * BryStepper Component
 * @param {Array} steps - Array of strings representing the steps
 * @param {number} currentStep - 1-indexed current step number
 */
const BryStepper = ({ steps = [], currentStep = 1 }) => {
  return (
    <div className="d-flex align-items-center justify-content-between w-100 mb-4 px-2 position-relative">
      {/* Background line */}
      <div 
        className="position-absolute top-50 start-0 end-0 translate-middle-y z-0" 
        style={{ height: '2px', background: '#E2E8F0', left: '20px', right: '20px' }}
      ></div>

      {/* Progress line */}
      <motion.div 
        className="position-absolute top-50 start-0 translate-middle-y z-0" 
        style={{ height: '2px', background: '#0EABB0', left: '20px' }}
        initial={{ width: '0%' }}
        animate={{ width: `${Math.min(((currentStep - 1) / (steps.length - 1)) * 100, 100)}%` }}
        transition={{ duration: 0.3 }}
      ></motion.div>

      {/* Steps */}
      {steps.map((step, index) => {
        const stepNum = index + 1;
        const isActive = stepNum === currentStep;
        const isCompleted = stepNum < currentStep;

        return (
          <div key={index} className="d-flex flex-column align-items-center position-relative z-1" style={{ flex: 1 }}>
            <motion.div
              className="rounded-circle d-flex align-items-center justify-content-center shadow-sm"
              style={{
                width: '32px',
                height: '32px',
                background: isCompleted || isActive ? '#0EABB0' : '#FFFFFF',
                color: isCompleted || isActive ? '#FFFFFF' : '#94A3B8',
                border: `2px solid ${isCompleted || isActive ? '#0EABB0' : '#E2E8F0'}`,
                fontWeight: 'bold',
                fontSize: '14px',
                transition: 'all 0.3s ease'
              }}
              whileHover={{ scale: 1.05 }}
            >
              {isCompleted ? <FontAwesomeIcon icon={faCheck} size="sm" /> : stepNum}
            </motion.div>
            <span 
              className="mt-2 text-center"
              style={{ 
                fontSize: '11px', 
                fontWeight: isActive ? 700 : 500,
                color: isActive ? '#1E293B' : '#64748B',
                maxWidth: '80px',
                lineHeight: '1.2'
              }}
            >
              {step}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default BryStepper;
